/** Legal copy aligned with WasOK `docs/PRIVACY_POLICY.md` / `docs/TERMS_OF_SERVICE.md`. */
export const legalMessagesRo = {
  privacy: {
    pageTitle: "Politica de confidențialitate",
    lastUpdated: "Ultima actualizare: 1 iunie 2026",
    introduction: {
      title: "Introducere",
      body: "WasOK este o aplicație de ajutor la cumpărături, local-first, concepută pentru a ajuta utilizatorii să își amintească produsele pe care le-au cumpărat, evaluat sau recenzat anterior.\n\nAceastă Politică de confidențialitate explică ce informații sunt prelucrate atunci când folosiți aplicația, cum sunt stocate datele și cum pot funcționa anumite servicii terțe.",
    },
    dataStored: {
      title: "Date stocate de aplicație",
      body: "WasOK stochează următoarele informații local pe dispozitivul dvs.:\n\n• coduri de bare ale produselor scanate\n• denumiri și detalii de produse introduse de utilizator\n• evaluări și comentarii\n• liste de cumpărături\n• categorii de produse\n• prețuri și informații despre magazine\n• fotografii ale produselor și magazinelor\n\nDatele și fotografiile dvs. de produse nu sunt încărcate pe serverele WasOK.",
    },
    permissions: {
      title: "Permisiuni folosite",
      camera: {
        title: "Cameră",
        body: "Accesul la cameră este folosit pentru:\n\n• scanarea codurilor de bare\n• fotografierea produselor",
      },
      photos: {
        title: "Fotografii și media",
        body: "Accesul la fotografii sau galerie este folosit doar când:\n\n• atașați imagini la produse\n• restaurați copii de rezervă care conțin fotografii",
      },
      files: {
        title: "Acces la fișiere și stocare",
        body: "Accesul la fișiere poate fi folosit pentru:\n\n• exportul fișierelor de backup\n• importul backup-urilor selectate de utilizator\n• partajarea listelor de cumpărături sau a backup-urilor",
      },
    },
    backup: {
      title: "Funcții de backup și export",
      body: "WasOK le permite utilizatorilor să creeze fișiere de backup care conțin datele aplicației și, opțional, fotografii.\n\nFișierele de backup sunt create local pe dispozitivul dvs. și pot fi stocate sau partajate folosind servicii alese de utilizator, cum ar fi:\n\n• Google Drive\n• Dropbox\n• iCloud Drive\n• stocare locală pe dispozitiv\n\nWasOK nu încarcă backup-urile pe propriile servere.",
      onlineProductLookup: {
        title: "Căutare online de produse",
        body: "Când activați căutarea online a codurilor de bare în Preferințe, WasOK poate trimite doar numărul codului de bare scanat către baze de date publice de produse (cum ar fi Open Food Facts) pentru a sugera un nume de produs și o marcă. WasOK nu încarcă evaluările, comentariile, fotografiile, listele de cumpărături, categoriile, informațiile despre magazine sau datele de backup pentru această funcție. Puteți dezactiva oricând această opțiune în Preferințe.",
      },
    },
    advertising: {
      title: "Publicitate și servicii terțe",
      intro:
        "WasOK folosește servicii terțe selectate pentru a oferi anumite funcții.",
      admob: {
        title: "Google AdMob",
        body: "Google AdMob este folosit pentru a afișa reclame în aplicație.\n\nGoogle și partenerii săi pot prelucra informații precum:\n\n• identificatori de publicitate\n• informații despre dispozitiv\n• adresa IP\n• informații de diagnostic și utilizare\n\nUtilizatorilor din anumite regiuni li se poate cere consimțământul înainte de afișarea reclamelor personalizate.",
      },
      crashlytics: {
        title: "Firebase Crashlytics",
        body: "WasOK folosește Firebase Crashlytics pentru a identifica blocările și a îmbunătăți stabilitatea aplicației.\n\nRapoartele de crash pot include informații tehnice precum:\n\n• modelul dispozitivului\n• versiunea sistemului de operare\n• versiunea aplicației\n• diagnostice de crash\n\nRapoartele de crash nu includ intenționat evaluările, notele, listele de cumpărături sau fotografiile dvs. de produse.",
      },
      externalProductDatabases: {
        title: "Baze de date externe de produse",
        body: "Funcționalitatea de căutare a codurilor de bare poate folosi baze de date externe de produse pentru a prelua informații despre produse.\n\nPentru mai multe informații, consultați politicile de confidențialitate ale furnizorilor respectivi.",
      },
    },
    dataSecurity: {
      title: "Securitatea datelor",
      body: "WasOK stochează datele aplicației local pe dispozitivul dvs. folosind mecanismele de stocare oferite de sistemul de operare.\n\nDeși se iau măsuri rezonabile pentru a proteja datele locale ale aplicației, nicio metodă de stocare electronică nu este complet sigură.\n\nUtilizatorii sunt responsabili pentru menținerea copiilor de rezervă ale datelor importante, dacă doresc.",
    },
    children: {
      title: "Confidențialitatea copiilor",
      body: "WasOK nu se adresează copiilor sub 13 ani.",
    },
    notifications: {
      title: "Notificări",
      body: "WasOK poate crea opțional notificări locale pe dispozitivul dvs. pentru a vă aminti să evaluați produsele după cumpărare.\n\nAceste notificări sunt generate și programate local pe dispozitivul dvs. și nu necesită un cont sau un server la distanță.\n\nPuteți dezactiva notificările oricând din setările dispozitivului sau din aplicație, dacă este suportat.",
    },
    yourControl: {
      title: "Controlul dvs. asupra datelor",
      body: "Puteți:\n\n• edita sau șterge produsele stocate oricând\n• șterge datele aplicației de pe dispozitiv\n• dezinstala aplicația\n• exporta backup-uri ale datelor dvs.",
    },
    changes: {
      title: "Modificări ale acestei politici",
      body: "Această Politică de confidențialitate poate fi actualizată din când în când.\n\nModificările intră în vigoare când este publicată versiunea actualizată.",
    },
    contact: {
      title: "Contact",
      body: "Dacă aveți întrebări privind această Politică de confidențialitate, contactați:\n\nsupport@wasok.app",
    },
  },
  terms: {
    pageTitle: "Termeni de utilizare",
    lastUpdated: "Ultima actualizare: 1 iunie 2026",
    acceptance: {
      title: "Acceptarea termenilor",
      body: "Prin descărcarea, instalarea sau utilizarea WasOK, sunteți de acord cu acești Termeni de utilizare.\n\nDacă nu sunteți de acord cu acești Termeni, nu trebuie să folosiți aplicația.",
    },
    license: {
      title: "Licență",
      body: "WasOK vă acordă o licență limitată, neexclusivă, netransferabilă și revocabilă de a folosi aplicația în conformitate cu acești Termeni.",
    },
    acceptableUse: {
      title: "Utilizare acceptabilă",
      body: "Sunteți de acord să nu:\n\n• folosiți greșit aplicația\n• interferați cu funcționarea aplicației\n• încercați să faceți reverse engineering sau să modificați aplicația\n• folosiți aplicația încălcând legile sau reglementările aplicabile",
    },
    localData: {
      title: "Date locale și backup-uri",
      body: "WasOK stochează datele utilizatorului local pe dispozitiv.\n\nUtilizatorii sunt responsabili pentru menținerea copiilor de rezervă ale datelor importante, dacă doresc.\n\nDeși poate fi oferită funcționalitate de backup și restaurare, WasOK nu garantează împotriva pierderii, coruperii sau eșecului datelor stocate.",
    },
    advertisements: {
      title: "Reclame",
      body: "Aplicația poate afișa reclame furnizate de parteneri de publicitate terți, inclusiv Google AdMob.",
    },
    noWarranty: {
      title: "Fără garanție",
      body: "WasOK este furnizat „ca atare” și „conform disponibilității”, fără garanții de niciun fel, exprese sau implicite.\n\nNu garantăm că:\n\n• aplicația va fi întotdeauna disponibilă\n• aplicația va fi fără erori\n• pierderea datelor nu va avea loc niciodată\n• toate funcțiile vor funcționa fără întreruperi pe toate dispozitivele",
    },
    limitationLiability: {
      title: "Limitarea răspunderii",
      body: "În măsura maximă permisă de lege, WasOK și dezvoltatorii săi nu vor fi răspunzători pentru:\n\n• pierderea datelor\n• pierderea profiturilor\n• problemele dispozitivului\n• daunele indirecte sau consecutive\n• întreruperile rezultate din utilizarea sau imposibilitatea de a utiliza aplicația",
    },
    thirdParty: {
      title: "Servicii terțe",
      body: "Anumite funcții sau conținuturi pot depinde de servicii terțe, inclusiv furnizori de publicitate și servicii externe de stocare/partajare selectate de utilizator.\n\nWasOK nu este responsabil pentru serviciile terțe sau politicile acestora.",
    },
    productInformation: {
      title: "Informații despre produse",
      body: "Anumite detalii despre produse pot fi obținute de la servicii terțe de căutare a codurilor de bare.\n\nWasOK nu garantează acuratețea, exhaustivitatea, disponibilitatea sau adecvarea informațiilor furnizate de surse de date externe.\n\nUtilizatorii ar trebui să verifice independent informațiile despre produse atunci când este necesar.",
    },
    changesApp: {
      title: "Modificări ale aplicației",
      body: "WasOK poate fi modificat, actualizat, suspendat sau întrerupt oricând, fără notificare prealabilă.",
    },
    changesTerms: {
      title: "Modificări ale acestor termeni",
      body: "Acești Termeni pot fi actualizați periodic.\n\nContinuarea utilizării aplicației după ce actualizările intră în vigoare constituie acceptarea Termenilor revizuiți.",
    },
    contact: {
      title: "Contact",
      body: "Pentru întrebări privind acești Termeni, contactați:\n\nsupport@wasok.app",
    },
  },
};
